import { http } from "../http-common";

const FetchAllHierarchy = (query) => {
  return http.get(`importLogHeader/ImportHierarchy?pageNumber=0&pageSize=100`);
};


const addLevel = (data) => {
  return http.post("/hierarchyLevelConfig", data);
};
const updateData = (data) => {
  return http.put("/hierarchyLevelConfig", data);
};
const deleteLevel = (id) => {
  return http.delete("/hierarchyLevelConfig/" + id);
};
const updateSequence = (data) => {
  return http.put(
    `/hierarchyLevelConfig/sequence?oldSequence=${data.old}&newSequence=${data.new}`
  );
};

const FetchAllHierarchyViewLog = (query) => {
    const params = new URLSearchParams();
    params.append("pageNumber", query.pageNumber);
    params.append("pageSize", query.size);
    if (query.status) {
      params.append("status", query.status);
    }
  
    return http.get(`/hierarchy-import/${query.id}?${params.toString()}`);
  };
  const FetchAllFarmerViewLog = (query) => {
    const params = new URLSearchParams();
    params.append("pageNumber", query.pageNumber);
    params.append("size", query.size);
    if (query.status) {
      params.append("status", query.status);
    }
  
    return http.get(`/farmer-import/logs?importId=${query.id}&${params.toString()}`);
  };
  const fetchFarmerDetail = (query) => {
    return http.get(`/farmer-import/log/${query.id}`);
  };

const ImportHierarchyService = {
  FetchAllHierarchy,
  addLevel,
  updateData,
  deleteLevel,
  updateSequence,
  FetchAllHierarchyViewLog,
  FetchAllFarmerViewLog,
  fetchFarmerDetail
};

export default ImportHierarchyService;
